<template>
    <div class="projet-pokepuller">
        <div class="back-button" @click="$router.push('/projets')">
            <i class="fas fa-arrow-left"></i> Retour
        </div>
        <div class="projet-header">
            <div class="header-content">
                <img src="@/assets/logo_pokepuller.png" alt="Logo PokePuller" class="projet-logo">
                <div class="header-text">
                    <h1>Bot Discord "PokePuller"</h1>
                    <div class="projet-meta">
                        <span class="date">Avril 2025</span>
                        <span class="category personal">Projet Personnel</span>
                    </div>
                    <div class="competences-badges">
                        <span class="competence-badge">Gérer le patrimoine informatique</span>
                        <span class="competence-badge">Répondre aux incidents et aux demandes d'assistance et d'évolution</span>
                        <span class="competence-badge">Mettre à disposition des utilisateurs un service informatique</span>
                        <span class="competence-badge">Développer la présence en ligne de l'organisation</span>
                        <span class="competence-badge">Travailler en mode projet</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="projet-content">
            <section class="projet-section">
                <h2>Présentation du projet</h2>
                <p>
                    PokePuller est un bot Discord développé en JavaScript sur Node.js qui permet aux utilisateurs de
                    simuler
                    l'ouverture de boosters Pokémon du Trading Card Game officiel. Ce projet personnel combine ma
                    passion
                    pour le développement et pour l'univers Pokémon, tout en offrant une expérience ludique et sociale
                    aux membres des serveurs Discord.
                </p>
            </section>

            <section class="projet-section">
                <h2>Ouverture de boosters</h2>
                <p>
                    Le cœur de l'expérience PokePuller est l'ouverture de boosters virtuels. Chaque booster contient
                    un assortiment de cartes de différentes raretés, fidèlement reproduites à partir du jeu de cartes
                    officiel.
                </p>
                <div class="feature-showcase">
                    <img src="@/assets/pokepuller_booster.png" alt="Ouverture d'un booster Pokémon"
                        class="feature-image">
                    <div class="feature-description">
                        <h3>Caractéristiques</h3>
                        <ul>
                            <li>Ouverture manuelle de l'utilisateur</li>
                            <li>Effets visuels pour les cartes rares reverse</li>
                            <li>Booster aléatoire gratuit tout les 2h</li>
                            <li>Répartition des raretés fidèle au vrai jeu</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Gestion de collection</h2>
                <p>
                    Chaque utilisateur dispose d'un inventaire personnel où sont stockées toutes les cartes obtenues.
                    L'interface de collection permet de consulter facilement ses cartes, de les trier par date, rareté,
                    par favoris, par doublons, parreverse ou pas noms,
                    et de suivre sa progression vers une collection complète.
                </p>
                <div class="feature-showcase reverse">
                    <div class="feature-description">
                        <h3>Fonctionnalités</h3>
                        <ul>
                            <li>Visualisation détaillée de chaque carte</li>
                            <li>Affichage Visuel ou Textuel</li>
                            <li>Système de filtres avancés</li>
                            <li>Affichage des cartes manquantes depuis l'inventaire des autres</li>
                        </ul>
                    </div>
                    <img src="@/assets/pokepuller_inv.png" alt="Interface de collection PokePuller"
                        class="feature-image">
                </div>
            </section>

            <section class="projet-section">
                <h2>Boutique virtuelle</h2>
                <p>
                    La boutique PokePuller permet aux utilisateurs de dépenser leur PokéDollars pour acquérir
                    de nouveaux boosters. Différentes promotions et offres
                    limitées sont régulièrement proposées pour dynamiser l'expérience.
                </p>
                <div class="feature-showcase">
                    <img src="@/assets/pokepuller_shop.png" alt="Boutique PokePuller" class="feature-image">
                    <div class="feature-description">
                        <h3>Options d'achat</h3>
                        <ul>
                            <li>Boosters de différentes séries</li>
                            <li>Roulement dynamique à minuit</li>
                            <li>Système de réduction aléatoire d'un booster</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Système de paliers</h2>
                <p>
                    Pour encourager l'engagement des utilisateurs, PokePuller intègre un système de paliers et de
                    récompenses.
                    En atteignant certains objectifs de collection ou d'activité, les joueurs débloquent des récompenses
                    spéciales.
                </p>
                <div class="feature-showcase reverse">
                    <div class="feature-description">
                        <h3>Fonctionnement</h3>
                        <ul>
                            <li>Décompte de statistiques par utilisateurs</li>
                            <li>Récompenses à chaques palliers atteints</li>
                            <li>Suivi d'un tableau "leaderboard"</li>
                        </ul>
                    </div>
                    <img src="@/assets/pokepuller_milestones.png" alt="Système de paliers PokePuller"
                        class="feature-image">
                </div>
            </section>

            <section class="projet-section">
                <h2>Échange de cartes</h2>
                <p>
                    Le système d'échange permet aux utilisateurs d'interagir entre eux pour compléter leurs collections.
                    Les échanges sont sécurisés par un processus de validation en plusieurs étapes, garantissant
                    une expérience équitable et sans risque de fraude.
                </p>
                <div class="feature-showcase">
                    <img src="@/assets/pokepuller_trade.png" alt="Interface d'échange PokePuller" class="feature-image">
                    <div class="feature-description">
                        <h3>Mécanismes d'échange</h3>
                        <ul>
                            <li>Proposition d'offres personnalisées</li>
                            <li>Système de validation bilatérale</li>
                            <li>Historique des transactions</li>
                            <li>Echange de cartes et de PokeDollars</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Technologies utilisées</h2>
                <div class="skills-grid">
                    <div class="skill-item">
                        <h3>Base de données</h3>
                        <p>PostgreSQL pour le stockage persistant, avec indexation optimisée pour les requêtes
                            fréquentes</p>
                    </div>
                    <div class="skill-item">
                        <h3>Intégration API</h3>
                        <p>Discord.js pour l'interface avec Discord, Axios pour les requêtes HTTP vers l'API Pokémon TCG
                        </p>
                    </div>
                    <div class="skill-item">
                        <h3>Rendu graphique</h3>
                        <p>Canvas pour générer des images dynamiques des cartes et des boosters</p>
                    </div>
                    <div class="skill-item">
                        <h3>Automatisation</h3>
                        <p>Cron pour la planification des tâches et événements récurrents</p>
                    </div>
                </div>
            </section>

            <section class="projet-section">
                <h2>Défis et solutions</h2>
                <p>
                    Le développement de PokePuller a présenté plusieurs défis techniques intéressants :
                </p>
                <p>
                    L'un des enjeux principaux c'est la fiabilité et la vitesse d'exécution de l'application.
                    Dans un premier temps, j'ai utilisé une API publique pour les données de chaque cartes Pokémon.
                    Cette solution n'était pas viable car je ne maîtrisais pas la rapidité de son exécution, les images
                    étaient trop lourdes et prennaient du temps à charger (.png), même avec un système de cache,
                    et il arrivais qu'elle soit indisponible ou avec des données éronnées.
                    J'ai donc créé ma propre API sur un serveur python avec mes propres données, optimisée pour répondre
                    vite, être toujours à jour et surtout, être faite sur-mesure pour fonctionner en parfaite adéquation
                    avec PokéPuller et PokéPullerWeb.
                </p>
                <p>
                    La sécurité et la disponibilité est aussi au centre des enjeux, car je souhaite que mon application soit disponible 99.99% du temps et qu'en cas de problème, qu'il n'y ai aucune perte de données.
                    Il existe de nombreuses sécurités qui gravitent autours de mon installation et des sauvegardes régulières automatisées.
                </p>
            </section>

            <section class="projet-section">
                <h2>Conclusion</h2>
                <p>
                    PokePuller est un projet qui démontre ma capacité à concevoir et développer une application
                    complète,
                    de la gestion de base de données à l'interface utilisateur, en passant par l'intégration d'APIs
                    tierces.
                    Ce bot Discord a permis d'animer plusieurs communautés et continue d'évoluer avec de nouvelles
                    fonctionnalités
                    basées sur les retours des utilisateurs.
                </p>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjetPokePuller'
}
</script>

<style scoped>
.projet-pokepuller {
    padding: 2rem;
    min-height: 100vh;
    max-width: 1200px;
    margin: 0 auto;
    color: #e0e0e0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    color: #FFD700;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    cursor: pointer;
    transition: color 0.3s;
}

.back-button:hover {
    color: #FFF176;
}

.projet-header {
    margin-bottom: 3rem;
    border-bottom: 2px solid #FFD700;
    padding-bottom: 1.5rem;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.projet-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #FFD700;
}

.header-text {
    flex: 1;
}

h1 {
    color: #FFD700;
    font-size: 2.8rem;
    margin-bottom: 1rem;
}

.projet-meta {
    display: flex;
    gap: 1.5rem;
    font-size: 1.1rem;
}

.date {
    color: #FFF176;
}

.category {
    padding: 0.3rem 1rem;
    border-radius: 20px;
    font-weight: 500;
}

.category.personal {
    background-color: rgba(255, 215, 0, 0.1);
    color: #FFD700;
    border: 1px solid #FFD700;
}

.projet-section {
    margin-bottom: 3rem;
}

h2 {
    color: #FFF176;
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid #FFD700;
    padding-left: 1rem;
}

h3 {
    color: #FFF59D;
    font-size: 1.4rem;
    margin-bottom: 1rem;
}

p {
    line-height: 1.7;
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
    color: #B0BEC5;
}

.feature-showcase {
    display: flex;
    gap: 2rem;
    margin: 2rem 0;
    align-items: center;
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 2rem;
}

.feature-showcase.reverse {
    flex-direction: row-reverse;
}

.feature-image {
    width: 50%;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.feature-description {
    flex: 1;
}

.infrastructure-grid,
.skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin: 2rem 0;
}

.infra-item,
.skill-item {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 1.5rem;
}

ul {
    padding-left: 1.5rem;
}

li {
    margin-bottom: 0.8rem;
    line-height: 1.5;
}

.architecture-diagram {
    background: rgba(1, 1, 11, 0.95);
    border: 1px solid #FFD700;
    border-radius: 8px;
    padding: 2rem;
    margin: 2rem 0;
    text-align: center;
}

.schema-image {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
}

.competences-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
}

.competence-badge {
    font-size: 0.82rem;
    font-style: italic;
    padding: 0.2rem 0.7rem;
    border-radius: 4px;
    border-left: 2px solid rgba(255, 215, 0, 0.5);
    color: #FFE082;
    background: rgba(255, 215, 0, 0.1);
}

@media screen and (max-width: 768px) {

    .infrastructure-grid,
    .skills-grid {
        grid-template-columns: 1fr;
    }

    .header-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .projet-logo {
        width: 60px;
        height: 60px;
    }

    .feature-showcase,
    .feature-showcase.reverse {
        flex-direction: column;
    }

    .feature-image {
        width: 100%;
        margin-bottom: 1.5rem;
    }

    .feature-description {
        width: 100%;
    }
}
</style>
